<div class="print-container">
    <ng-content></ng-content>
</div>
